import { Routes } from '@angular/router';
import { Anuidades } from '@/features/configuracoes/arrecadacao/anuidades/anuidades';
import { AnuidadeDetalhe } from '@/features/configuracoes/arrecadacao/anuidades/componentes/anuidade-detalhe/anuidade-detalhe';
import { Email } from '../geral/email/email';
import { BancoContaConvenio } from '@/features/configuracoes/arrecadacao/banco-conta-convenio/banco-conta-convenio';
import { CONFIGURACOES_ROUTES } from '@/features/configuracoes/configuracoes.constants';

const rootPath = CONFIGURACOES_ROUTES.ARRECADACAO.ROOT;

export const configuracoesArrecadacaoRoutes: Routes = [
    {
        path: rootPath,
        data: { breadcrumb: 'Arrecadação' },
        children: [
            { path: '', redirectTo: CONFIGURACOES_ROUTES.ARRECADACAO.ANUIDADES, pathMatch: 'full' },
            { path: CONFIGURACOES_ROUTES.ARRECADACAO.ANUIDADES, component: Anuidades, data: { breadcrumb: 'Anuidades' } },
            { path: CONFIGURACOES_ROUTES.ARRECADACAO.ANUIDADES_NOVO, component: AnuidadeDetalhe, data: { breadcrumb: 'Nova Configuração de Débito' } },
            { path: CONFIGURACOES_ROUTES.ARRECADACAO.ANUIDADES_DETALHE, component: AnuidadeDetalhe, data: { breadcrumb: 'Configuração de Débito' } },
            { path: CONFIGURACOES_ROUTES.ARRECADACAO.EMAIL, component: Email, data: { breadcrumb: 'Configurações Gerais' } },
            { path: CONFIGURACOES_ROUTES.ARRECADACAO.BANCOS, component: BancoContaConvenio, data: { breadcrumb: 'Bancos, contas e convênios' } }
        ]
    }
];

export default configuracoesArrecadacaoRoutes;
